module.exports = __webpack_public_path__ + "img/connect4Screenshot.115467ed.png";